import { LOGOUT_URI, LOGIN_URL } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";

export const logout = (): ApiResponse => appFetch.get(LOGOUT_URI, {});

export const login = (token: string): ApiResponse =>
  appFetch.post(LOGIN_URL, {
    isRawResponse: true,
    headers: {
      token,
    },
    config: {
      credentials: "include",
    },
    statusMessageConfig: {
      401: "Invalid Username or Password",
    },
  });
